import { adupVideoClick } from "@/api/getData.js";
export const myMixin = {
    methods: {
        gotoFreeTrial() {
            this.$router.push("/freetrial");
        },
        gotoFreeTrialPE() {
            this.$router.push("/freetrialPE");
        },
        gotoPath(str) {
            this.$router.push(str);
        },
        async VideoClick(type,title) {
            let vi = localStorage.getItem("viclick"+type);
            if (vi == undefined) {
                let obj = {
                    title: title,
                    type: type,
                };
                await adupVideoClick(obj);
                localStorage.setItem("viclick"+type, 1);
            }
        },
    },
};
